import { InfoHeaderCombinedProps } from './types';

const usePresenter = (props: InfoHeaderCombinedProps): InfoHeaderCombinedProps => {
  return props;
};

export default usePresenter;
